module.exports = __webpack_public_path__ + "static/media/02CED41A-56FF-4A8F-9C66-78759BA20AF6_Small.d16d312d.jpg";